import Manage from './views/Manage.vue';

export default [
  {
    path: 'manage',
    component: Manage,
    name: '账户管理',
  },
];
